import { createAction } from 'redux-actions'

export const receiveMultiEmbeds = createAction('RECEIVE_MULTI_EMBEDS')
export const updateChildEmbed = createAction('UPDATE_CHILD_EMBED')
export const receiveUpdatedChildEmbed = createAction(
  'RECEIVE_UPDATED_CHILD_EMBED'
)
export const receiveHasMultiEmbed = createAction('RECEIVE_MULTI_EMBED')
export const receiveBulkTargeting = createAction('RECEIVE_BULK_TARGETING')
export const receiveTargeting = createAction('RECEIVE_TARGETING')
export const receiveHasMultiLanguageDowngrade = createAction(
  'RECEIVE_HAS_MULTI_LANGUAGE_DOWNGRADE'
)
